module.exports = "<div ng-click=\"journalCtrl.contextMenu.show = false\" class=\"gridDocumentMovementStyleWrapper\">\r\n  <div ng-if=\"$ctrl.options\" \r\n       class=\"gridDocumentMovementStyle\" \r\n       ui-grid-selection\r\n       ui-grid-edit \r\n       ui-grid-row-edit\r\n       ui-grid=\"$ctrl.options\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/document-movements/document-movements.html
// module id = 59
// module chunks = 0